/**
* This handles the following:
*
* 1.  Navigation roll over for both the shop and collection
* 2.  Product zoom
* 3.  Product/collection share
* 4.  Iterating through photos
* 5.  Adjusts height of .product-details div if needed based on largest p
* 6.  Trim to see more details on product page
*
* Product/collection navigation should be similar to:
*  <a link data-tag="Shirt" data-collection></a> <li data-tags="Shirt, Suit, polyester" />
* Namespace singleProductHelpers
*
* @author Jonathon McDonald <jonathon@agencyfusion.com>
*/
var singleProductHelpers;
singleProductHelpers = {};
singleProductHelpers.collectionTimeout = null;
singleProductHelpers.productHeight = 0;
singleProductHelpers.height = 0;
singleProductHelpers.isZoomOn = false;
singleProductHelpers.shopTimeout = null;
singleProductHelpers.prodImgHeight = 0;
singleProductHelpers.totalInTag = 0;
singleProductHelpers.sleepTimeout = null;
singleProductHelpers.rtwTimeout = null;
singleProductHelpers.swimTimeout = null;
singleProductHelpers.saleTimeout = null;
singleProductHelpers.aboutTimeout = null;
singleProductHelpers.lookbookTimeout = null;
window.App.singleProductHelpers = singleProductHelpers;

/**
* Trims a description to the first paragraph,
* and appends a small link to toggle
* the rest of the description.
*
* isShown is optional
*/
singleProductHelpers.toggleDescription = function (selector, isShown) {
  counter = 0;
  if (selector === null) {
    return;
  }

  if (isShown === null) {
    isShown = false;
  }

  var pCount = $(selector + ' p').length;
  if (pCount <= 1) {
    return;
  }

  $(selector + ' p').each(function () {
    if (counter !== 0) {
      $(this).toggle();
    }
    counter = counter + 1;
  });

  selectorExists = $('.show-more-details').is('*');

  if (selectorExists === false) {
    $(selector).after("<a aria-expanded='false' class='show-more-details btn-details' href='#show-" + selector.substring(1) + "'>More Details</a>");
  }

  if (!selectorExists) {
    $('.show-more-details').click(function () {
      $(this).toggleClass('active')
      if (isShown === true) {
        isShown = false;
        $(this).html('More Details');
        $(this).attr('aria-expanded', false);
      } else {
        isShown = true;
        $(this).html('Hide Details');
        $(this).attr('aria-expanded', true);
      }
      singleProductHelpers.toggleDescription(selector, isShown);
    });
  }
};

/**
* This will hide all elements with the given class selector,
* and will then show the element with the photoSelector.  The
* photoSelector is used in conjunction with an image's data-index
* attribute
*/
singleProductHelpers.togglePhoto = function (classSelector, photoSelector) {
  if (classSelector === null || photoSelector === null) {
    return;
  }

  $(classSelector).addClass('no-display');
  $('img[data-index=' + photoSelector + ']').removeClass('no-display');
};

/**
* If zoom is turned on, this will essentially
* turn it off, and clean up DOM elements
* that zoom leaves behind
*/
singleProductHelpers.unbindZoom = function () {
  $('.product-photos').unbind();
  $('.zoomImg').remove();
  $('.product-photos').css('position', 'inherit');
  $('.zoom').html('Zoom');
  singleProductHelpers.isZoomOn = false;
};

/**
* Photo iterator helper, moves us forward to the next photo
*/
singleProductHelpers.nextPhoto = function () {
  var iter_pos, iter_count;
  iter_pos = parseInt($('#photo-iter-pos').html(), 10) - 1;
  iter_count = parseInt($('#photo-iter-count').html(), 10) - 1;

  $('.product-photo:not(.no-display)').addClass('no-display');

  if (singleProductHelpers.isZoomOn === true) {
    singleProductHelpers.unbindZoom();
  }

  iter_pos = iter_pos + 1;
  if (iter_pos > iter_count) {
    iter_pos = 0;
  }

  $('#photo-iter-pos').html(iter_pos + 1);
  $('.product-photo:eq(' + iter_pos + ')').removeClass('no-display');
};

/**
* Photo iterator helper, moves us to the previous photo
*/
singleProductHelpers.previousPhoto = function () {
  var iter_pos, iter_count;
  iter_pos = parseInt($('#photo-iter-pos').html(), 10) - 1;
  iter_count = parseInt($('#photo-iter-count').html(), 10) - 1;

  $('.product-photo:not(.no-display)').addClass('no-display');

  if (singleProductHelpers.isZoomOn === true) {
    singleProductHelpers.unbindZoom();
  }

  iter_pos = iter_pos - 1;
  if (iter_pos < 0) {
    iter_pos = iter_count;
  }

  $('#photo-iter-pos').html(iter_pos + 1);
  $('.product-photo:eq(' + iter_pos + ')').removeClass('no-display');
};

/* indexOf implementation for IE8, based on Mozilla's implementation. */
if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function (searchElement/*, fromIndex */) {
    "use strict";
    if (this == null) {
      throw new TypeError();
    }

    var t = Object(this);
    var len = t.length >>> 0;
    if (len === 0) {
      return -1;
    }

    var n = 0;
    if (arguments.length > 1) {
      n = Number(arguments[1]);
      if (n != n) { // shortcut for verifying if it's NaN
        n = 0;
      } else if (n != 0 && n != Infinity && n != -Infinity) {
        n = (n > 0 || -1) * Math.floor(Math.abs(n));
      }
    }

    if (n >= len) {
      return -1;
    }

    var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
    for (; k < len; k++) {
      if (k in t && t[k] === searchElement) {
        return k;
      }
    }

    return -1;
  }
}

/* Add String.contains() as neccessary. */
if(!('contains' in String.prototype))
  String.prototype.contains = function(str, startIndex) { return -1!==this.indexOf(str, startIndex); };

/* Namespace declaration. */
var productHelpers = {};

/**
* Using the provided selector this will
* set a drop down, with a default option of
* quantity (value = 1), and then fill from 1 to
* quantity. Selector should include the octothorpe,
* or the '.'
*/
productHelpers.changeQuantityDropdown = function (quantity, selector, currVal) {
  if (selector === null || quantity === null) {
    quantity = 0;
  }
  
  
  
  if (quantity > 4)
  {quantity=4;}
  
  var i = 1;

  $(selector).empty();
  if (currVal === null) {
    $(selector).append('<option value="1" selected=true>Quantity</option>');
  } else {
    $(selector).append('<option value="1">Quantity</option>');
  }

  for (i; i <= quantity; i++) {
    if (i === currVal) {
      $(selector).append('<option value="' + i + '" selected=true>' + i + '</option>');
    } else {
      $(selector).append('<option value="' + i + '">' + i + '</option>');
    }
  }
};


;(function ($) {
  'use strict';

  var counter = 0,
  selectorExists = false;

  /**
  * Now we can manipulate the DOM elements
  */
  $(document).ready(function () {
    $('.navbar .nav .main').each(function (index, element) {
      var hammertime = new Hammer(element);
      hammertime.on('doubletap', function (el) {
        window.location.href = $(element).attr('href');
      });
    });

    // For shop pagination to work properly we have to use a certain trick
    if (window.location.hash) {
      $('#prod-next').attr('href', $('#prod-next').attr('href') + window.location.hash);
      $('#prod-previous').attr('href', $('#prod-previous').attr('href') + window.location.hash);
    }

    // Search menu expands on mobile
    $('#mobile-search-icon').click(function () {
      $('.mobile-search').toggle();
    });

    // Addresses viewport repositioning on iOS devices
    if ('ontouchstart' in document.documentElement) {
      $('.mobile-search, .search, .newsletter-signup').click(function () {
        $('.navbar-fixed-top').addClass('fixfixed');
      });
    }

    var menuOpen = function () {
      $('.search-bar').hide();
      $('.nav > li > ul').hide();
      $('.nav > li > .featured-image').hide();
      var $ul = $(this).find('> ul');
      $ul.css('display', 'flex');
      $(this).find('> a').attr('aria-expanded', true);
      $(this).find('> ul').attr('aria-hidden', false);

      if (!$.isMobile.matches) {
        $ul.show();
        $ul.css('display', 'flex');
      } else {
        $ul.on('shown.bs.collapse', function () {
          $ul.css('display', 'flex');
        });
      }

      var $container = $ul.closest('.container');
      var width = $container.outerWidth() - ($ul.offset().left - $container.offset().left);
      var liWidths = 0;
      $ul.find('> li').each(function () {
        liWidths += $(this).outerWidth(true) + 1; // The one helps not round pixels down
      });
      $ul.css('width', width + 'px');
      var height = $ul.offset().top + $ul.outerHeight() - $container.offset().top;
      $('.navbar-backdrop').css('height', height + 'px');
      $('.navbar-backdrop').show();
    };

    var menuClose = function (ev) {
      // Correct the "this" problem setTimeout has
      // @see https://developer.mozilla.org/en-US/docs/DOM/window.setTimeout
      var $ul = $(this).find('> ul');

      $ul.css('display', 'none');
      $('.nav > li > a').attr('aria-expanded', false);
      $('.nav > li > ul').attr('aria-hidden', true);

      if (!$.isMobile.matches) {
        singleProductHelpers.shopTimeout = setTimeout(function () {
          $ul.hide();
        }, 150);
      } else {
        $ul.on('hidden.bs.collapse', function () {
          $ul.css('display', 'none');
        });
      }

      $('.navbar-backdrop').hide();
    }

    var $li = $('.navbar .nav > li');
    var $liA = $('.navbar .nav > li > a');
    $li.mouseenter(menuOpen).mouseleave(menuClose);
    $li.click(menuOpen).mouseleave(menuClose);
    $liA.keydown(function(event){
      var keyCode = (event.keyCode ? event.keyCode : event.which);
      if (keyCode == 40) {
        $(this).parent('li').trigger('mouseenter');
      }

      if (keyCode == 38) {
        $li.trigger('mouseleave');
      }
    });

    $(document).on('touchstart', function (e) {
      var touchedOutsideNavbar = !$(e.target).closest('.navbar').length;
      if (touchedOutsideNavbar) {
        $li.each(function () {
          $(this).trigger('mouseleave');
        });
      }
    });

    // Share button
    $('.share').click(function (e) {
      e.preventDefault();
      e.stopPropagation();

      $.modal.close();

      if (singleProductHelpers.isZoomOn) {
        singleProductHelpers.unbindZoom();
      }

      var thisAttr = $(this).attr('href');
      $(thisAttr).modal({
        close: true,
        closeClass: 'close',
        onClose: function (dialog) {
          $.modal.close();

          if (navigator.userAgent.indexOf("Firefox") !=-1 || navigator.userAgent.indexOf("MSIE 9.0") != -1) {
            $(thisAttr + ' .fb-like span').height(30);
            $(thisAttr + ' .fb-like span iframe').height(30);
          }
        }
      });
    });

    $('.collection-sidebar a').each(function () {
      if ($(this).attr('href') === window.location.pathname) {
        $(this).addClass('italic');
      }
    });

    // Zoom functionality
    if ('ontouchstart' in document.documentElement) {
      // Disables zoom on touch devices
      $('.zoom').hide();
    }

    $('.zoom').click(function (e) {
      e.preventDefault();
      e.stopPropagation();

      $.modal.close();
      if (singleProductHelpers.isZoomOn === false) {
        var x = $('.product-photo:not(.no-display)').attr('src');
        $('.product-photos').zoom({ url: x });
        $('.zoom').html('Turn Zoom Off');
        singleProductHelpers.isZoomOn = true;
      } else {
        singleProductHelpers.unbindZoom();
      }
    });

    // Since zoom messes the nav functionality up, this disables zoom if it's on
    $('#nav').hover(function () {
      if (singleProductHelpers.isZoomOn === true) {
        singleProductHelpers.unbindZoom();
      }
    });

    //hide links, etc.
    $('ul.collections-list li').hover(function () {
      $(this).find('div.details p').show();
    }, function () {
      $(this).find('div.details p').hide();
    });

    // Fixes product details paragraph height
    $('.product-details p').each(function () {
      var currHeight = parseInt($(this).height(), 10);
      $(this).attr('aria-expanded', false);
      if (currHeight > singleProductHelpers.height) {
        singleProductHelpers.height = currHeight;
        $(this).attr('aria-expanded', true);
      }
    });
    $('.product-details').height(singleProductHelpers.height);

    // Trim the description on a product page
    singleProductHelpers.toggleDescription("#prod-trim-desc");

    // Other image views...
    $('#other-views img, #other-views-mobile img').click(function (e) {
      e.preventDefault();

      if (singleProductHelpers.isZoomOn) {
        singleProductHelpers.unbindZoom();
      }

      singleProductHelpers.togglePhoto('.product-photo', $(this).data('ptr'));
    });
  });

  $(window).load(function () {
    var marginTopForProductImage;

    // Fixes product li img height, again needed to ensure proper layout
    /* $('.prod-li-img').each(function () {
      var currHeight = parseInt($(this).height());
      if (currHeight > singleProductHelpers.prodImgHeight) {
        singleProductHelpers.prodImgHeight = currHeight;
      }
    });
    $('.prod-li-img').height(singleProductHelpers.prodImgHeight);*/

    // Fixes product details paragraph height
    $('.product-details p').each(function () {
      var currHeight = parseInt($(this).height(), 10);
      if (currHeight > singleProductHelpers.height) {
        singleProductHelpers.height = currHeight;
      }
    });
    $('.product-details').height(singleProductHelpers.height);

    // Fixes product li height, again needed to ensure proper layout
    /*$('li.product-li').each(function () {
      var currHeight = parseInt($(this).height(), 10);
      if (currHeight > singleProductHelpers.productHeight) {
        singleProductHelpers.productHeight = currHeight;
      }
    });
    $('li.product-li').height(singleProductHelpers.productHeight);*/

    // Now let's vertically single page images
    $('.product-photo').each(function () {
      var childHeight;
      $(this).css({ // Optional if #myDiv is already absolute
        visibility: 'hidden',
        display:    'block'
      });

      childHeight = $(this).height();
      marginTopForProductImage = $('.seven-eighths').height() / 2 - childHeight / 2;

      $(this).css({
        position:   '', // Again optional if #myDiv is already absolute
        visibility: '',
        display:    ''
      });

      // Fix it from getting too big
      if (marginTopForProductImage > 150) {
        marginTopForProductImage = 150;
      }
    });

    $('.product-photo').first().removeClass('no-display');
  });
})(jQuery);
